import {
    CodeBlock, BlockType, SettingType, Define, SettingState, ValidationMessage,
} from '@appblocks/codegeneration/types';

import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';

export default class Timers extends BaseFeature {
    constructor() {
        super();
        this.name = 'Timers';
        this.id = 'timers';
        this.icon = 'IoIosTimer';
        const settings = [
            {
                id: 'DEBUG_PRINT',
                name: 'Debug Printing',
                settingType: SettingType.OPTION,
                default: '0',
                options: [
                    {
                        name: 'Disabled',
                        value: '0',
                    },
                    {
                        name: 'Enabled',
                        value: '1',
                    },
                ],
                helpText: 'When this option is enabled, the start and expiration of each timer are printed to the logging display (selected in the General features page).',
            },
            {
                id: 'TIMERS',
                name: 'Timers',
                settingType: SettingType.ARRAY,
                required: true,
                refId: 'timer',
                default: new Array<BaseFeature>(0),
                helpText: 'Timers are used in blocks to trigger events on specified time intervals.',
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getDefines(): Array<Define> {
        const DEBUG_PRINT = this.getSettingValue('DEBUG_PRINT') === '1';
        if (DEBUG_PRINT) {
            return [{
                name: 'TIMER_DEBUG_PRINT',
                value: '1',
            }];
        }
        return [];
    }

    getEnabled(): boolean {
        const TIMERS = this.getSettingValue('TIMERS');
        return TIMERS.length > 0;
    }

    getCodeBlocks() {
        let blocks: Array<CodeBlock> = [];

        const TIMERS = this.getSettingValue('TIMERS');

        for (let i = 0; i < TIMERS.length; i += 1) {
            blocks = blocks.concat(TIMERS[i].getCodeBlocks());
        }

        return blocks;
    }

    getDetails(): string {
        return `
## Timers
This feature allows you to create one shot timers that can be started via triggers in AppBlocks

Timers can be used in the **On Timer**, **Timer Start**, and **Timer Stop** blocks:

![timers blocks](/static/img/blocks_timers.png) 

### Timer Start
This block starts a timer. The timer will expire after the specified number of seconds. When the timer expires, the **On Timer** block will be triggered.

### Timer Stop
This block stops a timer. If the timer is already stopped, this block has no effect.

### On Timer
This block is triggered when a timer expires.
        `;
    }
}
